import { render, staticRenderFns } from "./CreateShipmentForm.vue?vue&type=template&id=48daf00a&scoped=true&"
import script from "./CreateShipmentForm.vue?vue&type=script&lang=js&"
export * from "./CreateShipmentForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateShipmentForm.vue?vue&type=style&index=0&id=48daf00a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48daf00a",
  null
  
)

export default component.exports